import CrudService from "@utils/CrudService";

class GrupoService extends CrudService {}

export const BaseGrupoService = GrupoService

export default new GrupoService({
    domainName:'comercio',
    entityName:'grupo',
    fields: {
        'grupo': ['name', 'description', 'phone', 'email', 'master_id', 'comercializadora_id', 'is_active'],
        'user': ['username', 'password', 'is_active']
    },
    query:['search', 'slug', 'is_active', 'offset', 'limit', 'comercializadora_id', 'master_id'],
});